import React from "react";
import { RotateCcw, CheckCircle2, XCircle, Wallet, Mail } from "lucide-react";
import PageShell, { Section } from "../components/PageShell";

export default function Reembolsos() {
  return (
    <PageShell
      title="Política de Reembolso"
      subtitle="A tua satisfação é a nossa prioridade. Tens 30 dias para devolver e ser reembolsado."
      breadcrumb="Devoluções & Reembolsos"
    >
      <div className="grid sm:grid-cols-3 gap-4 not-prose">
        {[
          { icon: RotateCcw, title: "30 dias", desc: "Prazo para devolução" },
          { icon: Wallet, title: "Reembolso total", desc: "No método de pagamento original" },
          { icon: CheckCircle2, title: "Processo simples", desc: "Sem complicações" },
        ].map((c) => (
          <div key={c.title} className="border border-border rounded-lg p-5 bg-card">
            <c.icon className="h-6 w-6 text-primary mb-3" />
            <p className="font-medium text-foreground">{c.title}</p>
            <p className="text-sm text-muted-foreground mt-1">{c.desc}</p>
          </div>
        ))}
      </div>

      <Section title="Direito de devolução">
        <p>
          Tens o direito de devolver qualquer produto no prazo de <strong>30 dias</strong> a
          contar da data de receção da encomenda, sem necessidade de justificação. Este prazo
          é mais alargado do que o mínimo legal de 14 dias, porque queremos que compres com
          total confiança.
        </p>
      </Section>

      <Section title="Condições para devolução">
        <p>Para que a devolução seja aceite, o produto deve:</p>
        <ul className="not-prose space-y-2">
          {[
            "Estar em bom estado e sem sinais de uso excessivo",
            "Incluir a embalagem original e todos os acessórios",
            "Manter as etiquetas e selos de higiene intactos",
            "Ser acompanhado do comprovativo de compra",
          ].map((item) => (
            <li key={item} className="flex items-start gap-2 text-sm">
              <CheckCircle2 className="h-4.5 w-4.5 h-4 w-4 text-primary mt-0.5 shrink-0" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </Section>

      <Section title="Produtos não elegíveis">
        <p>Por motivos de higiene e segurança, não são aceites devoluções de:</p>
        <ul className="not-prose space-y-2">
          {[
            "Produtos com selo de higiene aberto ou violado",
            "Artigos usados de forma que impeça a revenda",
            "Cartões de oferta e produtos personalizados",
          ].map((item) => (
            <li key={item} className="flex items-start gap-2 text-sm">
              <XCircle className="h-4.5 w-4.5 h-4 w-4 text-muted-foreground mt-0.5 shrink-0" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </Section>

      <Section title="Como devolver um produto">
        <ol className="not-prose space-y-4">
          {[
            { t: "Contacta-nos", d: "Envia um email para devolucoes@radix.pt com o número da encomenda e o motivo da devolução." },
            { t: "Recebe as instruções", d: "Em 24h úteis enviamos a etiqueta de devolução e as instruções de envio." },
            { t: "Envia o produto", d: "Embala o produto com segurança e usa a etiqueta fornecida." },
            { t: "Recebe o reembolso", d: "Após recebermos e verificarmos o produto, processamos o reembolso." },
          ].map((step, i) => (
            <li key={i} className="flex gap-4">
              <span className="h-8 w-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-semibold shrink-0">
                {i + 1}
              </span>
              <div>
                <p className="font-medium text-foreground">{step.t}</p>
                <p className="text-sm text-muted-foreground mt-0.5">{step.d}</p>
              </div>
            </li>
          ))}
        </ol>
      </Section>

      <Section title="Reembolsos">
        <p>
          Após a receção e verificação do produto devolvido, o reembolso é processado no prazo
          de <strong>5 a 10 dias úteis</strong>, através do mesmo método de pagamento utilizado
          na compra. Receberás um email de confirmação assim que o reembolso for emitido.
        </p>
        <p className="text-sm">
          Nota: o tempo até o valor aparecer na tua conta depende do banco ou entidade de
          pagamento.
        </p>
      </Section>

      <Section title="Trocas">
        <p>
          Queres trocar por outro modelo ou cor? O processo é o mesmo de uma devolução:
          devolves o artigo e efetuas uma nova encomenda. Assim garantimos que recebes
          rapidamente o produto certo.
        </p>
      </Section>

      <Section title="Produtos com defeito">
        <div className="flex items-start gap-3 not-prose bg-secondary/50 border border-border rounded-lg p-4">
          <Mail className="h-5 w-5 text-primary mt-0.5 shrink-0" />
          <p className="text-sm text-muted-foreground">
            Se recebeste um produto com defeito ou incorreto, contacta-nos de imediato para
            <strong> devolucoes@radix.pt</strong>. Todos os dispositivos têm garantia de 2 anos
            e trataremos da substituição ou reembolso sem qualquer custo para ti.
          </p>
        </div>
      </Section>
    </PageShell>
  );
}
